import React, { Fragment, useState, useEffect } from 'react';
import WebsiteVisitsChartCard from '../../../dashboards/components/cards/WebsiteVisitsChartCard';
import Contact from '../../../dashboards/components/cards/Contact';
import 'moment-timezone';

import {
  Row,
  Col,
  Card,
  CardBody,
  UncontrolledDropdown,
  DropdownItem,
  DropdownToggle,
  DropdownMenu,
  Spinner,
} from 'reactstrap';
import Axios from 'axios';
import { AxiosAPI, getGroupID } from '../../../../../helpers/AxiosAPI';
import {
  week,
  month,
  last7Days,
  last30Days,
  last90Days,
  year,
} from '../../../dashboards/components/cards/lablesConfig';
import moment from 'moment';
import IntlMessages from '../../../../../helpers/IntlMessages';
import { faLock, faLockOpen } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
  gAPI_VisitorsGroups_Stats,
  gAPI_VisitorsGroupsContact_Stats,
  gAPI_Voucher_Stats,
  gAPI_Voucher_Engine_Stats,
  gAPI_Voucher_Engine_Sales,
  gAPI_Voucher_Country_Stats,
} from '../../../../../constants/APIs';
import VoucherClicks from '../../../dashboards/components/cards/VoucherClicks';
import VoucherEngineSales from '../../../dashboards/components/cards/VoucherEngineSales';
import PopularVoucher from '../../../dashboards/components/cards/PopularVoucher';
import RecentOrder from '../../../dashboards/components/cards/RecentOrder';
import VoucherEngineVisits from '../../../dashboards/components/cards/VoucherEngineVisits';
import { injectIntl } from 'react-intl';
import { connect } from 'react-redux';

const voucherEngineVisits = [
  {
    Header: <IntlMessages id='dashboards.country' />,
    accessor: 'country',
    Cell: (props) => <p className="">{props.value}</p>,
  },
  {
    Header: <IntlMessages id='dashboards.clicks' />,
    accessor: 'clicks',
    Cell: (props) => (
      <p className="popular-voucher" style={{ marginLeft: '2rem!important' }}>
        {props.value}
      </p>
    ),
  },
  {
    Header: 'Visitors',
    accessor: 'visitors',
    Cell: (props) => (
      <p className="popular-voucher" style={{ marginLeft: '2rem!important' }}>
        {props.value}
      </p>
    ),
  },
];
const poupularVoucherDataTablescolumn = [
  {
    Header: <IntlMessages id='dashboards.name' />,
    accessor: 'voucherName',
    Cell: (props) => <p style={{ whiteSpace: 'normal' }}>{props.value}</p>,
  },
  {
    Header: 'Views',
    accessor: 'views',
    Cell: (props) => (
      <p className="popular-voucher" style={{ marginLeft: '2rem!important' }}>
        {props.value}
      </p>
    ),
  },
  {
    Header: 'Added to Cart',
    accessor: 'cart',
    Cell: (props) => (
      <p className="popular-voucher" style={{ marginLeft: '2rem!important' }}>
        {props.value}
      </p>
    ),
  },
  {
    Header: 'Payments',
    accessor: 'payments',
    Cell: (props) => (
      <p className="popular-voucher" style={{ marginLeft: '2rem!important' }}>
        {props.value}
      </p>
    ),
  },
  {
    Header: 'Purchases',
    accessor: 'purchases',
    Cell: (props) => (
      <p className="popular-voucher" style={{ marginLeft: '2rem!important' }}>
        {props.value}
      </p>
    ),
  },
];
function Insights({
  propertyId,
  isVoucherEngine,
  timeZone,
  locale,
  domains,
  currency,
}) {
  moment.tz.setDefault(timeZone);
  const [buttonText, setButtonText] = useState(
    <IntlMessages id="dashboards.last-7-days" />
  );
  const [labels, setLabels] = useState(last7Days);
  const [visitorStatsData, setVisitorStatsData] = useState([]);
  const [contactStatsData, setContactStatsData] = useState([]);
  const [visitorQuestionsPageNumber, setvisitorQuestionsNumber] = useState(1);
  const [fromDate, setfromDate] = useState('');
  const [toDate, settoDate] = useState('');
  const [isWebsiteVisit, setIsWebsiteVisit] = useState(true);
  const [isContact, setContacts] = useState(true);
  const [clicks, setClicks] = useState([]);
  const [isclicks, setIsClicks] = useState(true);
  const [sales, setSales] = useState([]);
  const [isSales, setIsSales] = useState(true);
  const [stats, setStats] = useState([]);
  const [isStats, setIsStats] = useState(true);
  const [statsData, setStatsData] = useState([]);
  const [countryvisit, setCountryVisit] = useState([]);
  const [isCountryStats, setIsCountryStats] = useState(true);
  // const [propertyLoaded, setpropertyLoaded] = useState(propertyId);
  const [isMasked, setIsMasked] = useState(sessionStorage.getItem('lock'));
  const maskEmail = (text) => {
    if (text !== null && text !== undefined) {
      let maskedvalue = text.replace(/()(.*)(?=@)/, function (gp1, gp2, gp3) {
        for (let i = 0; i < gp3.length; i++) {
          gp2 += 'X';
        }
        return gp2;
      });
      return maskedvalue;
    } else return '';
  };
  const maskMobile = (text, number) => {
    if (text !== null && text !== undefined) {
      let maskedValue = '';
      for (let i = 0; i < text.length - number; i++) {
        maskedValue += 'X';
      }
      return maskedValue + text.substring(text.length - number, text.length);
    } else return '';
  };
  const dataTableColumnsContacts = [
    {
      Header: 'Name',
      accessor: 'name',
      Cell: (props) => <p className="">{props.value}</p>,
    },
    {
      Header: 'Email',
      accessor: 'email',
      Cell: (props) => (
        <p className="">
          {isMasked !== 'true' ? maskEmail(props.value) : props.value}
          <span
            className="text-muted ml-1"
            style={{ cursor: 'pointer' }}
            onClick={handleMaskClick}
          >
            {props.value !== '' && (
              <FontAwesomeIcon
                icon={isMasked === 'true' ? faLock : faLockOpen}
                className="fa"
              />
            )}
          </span>
        </p>
      ),
    },
    {
      Header: 'Phone',
      accessor: 'phone',
      Cell: (props) => (
        <p className="">
          {isMasked !== 'true' ? maskMobile(props.value, 4) : props.value}
          <span
            className="text-muted ml-1"
            style={{ cursor: 'pointer' }}
            onClick={handleMaskClick}
          >
            {props.value !== '' && (
              <FontAwesomeIcon
                icon={isMasked === 'true' ? faLock : faLockOpen}
                className="fa"
              />
            )}
          </span>
        </p>
      ),
    },
    {
      Header: 'Zip Code',
      accessor: 'zipCode',
      Cell: (props) => <p className="">{props.value}</p>,
    },
    {
      Header: <IntlMessages id='dashboards.marketingconsent' />,
      accessor: 'consent',
      Cell: (props) => <p className="">{props.value}</p>,
    },
    {
      Header: 'Date',
      accessor: 'consentDate',
      Cell: (props) => (
        <p className="">
          {props.value !== '' ? moment(props.value).format('lll') : ''}
        </p>
      ),
    },
  ];
  const handleMaskClick = () => {
    if (isMasked === 'true') {
      sessionStorage.setItem('lock', 'false');
      setIsMasked(sessionStorage.getItem('lock'));
    } else {
      sessionStorage.setItem('lock', 'true');
      setIsMasked(sessionStorage.getItem('lock'));
    }
  };
  useEffect(() => {
    if (propertyId !== '' && propertyId !== undefined) {
      selectLast7Days();
    }
  }, [propertyId]);

  const today = () => {
    return moment(moment().format('YYYY-MM-DD') + ' 23:59:59')
      .utc()
      .format('YYYY-MM-DD HH:mm:ss');
  };

  const daysAgo7 = () => {
    return moment(
      moment().subtract(6, 'days').format('YYYY-MM-DD') + ' 00:00:00'
    )
      .utc()
      .format('YYYY-MM-DD HH:mm:ss');
  };

  const daysAgo30 = () => {
    return moment(
      moment().subtract(29, 'days').format('YYYY-MM-DD') + ' 00:00:00'
    )
      .utc()
      .format('YYYY-MM-DD HH:mm:ss');
  };

  const daysAgo90 = () => {
    return moment(
      moment().subtract(89, 'days').format('YYYY-MM-DD') + ' 00:00:00'
    )
      .utc()
      .format('YYYY-MM-DD HH:mm:ss');
  };

  const startOfWeek = () => {
    const today = moment();
    return moment(
      moment(today).isoWeekday(1).format('YYYY-MM-DD') + ' 00:00:00'
    )
      .utc()
      .format('YYYY-MM-DD HH:mm:ss');
  };

  const endOfWeek = () => {
    const today = moment();
    return moment(
      moment(today).isoWeekday(7).format('YYYY-MM-DD') + ' 23:59:59'
    )
      .utc()
      .format('YYYY-MM-DD HH:mm:ss');
  };

  const startOfMonth = () => {
    return moment(moment().startOf('month').format('YYYY-MM-DD') + ' 00:00:00')
      .utc()
      .format('YYYY-MM-DD HH:mm:ss');
  };

  const startOfPreviousMonth = () => {
    return moment(
      moment().subtract(1, 'months').startOf('month').format('YYYY-MM-DD') +
      ' 00:00:00'
    )
      .utc()
      .format('YYYY-MM-DD HH:mm:ss');
  };

  const startOfThisYear = () => {
    return moment(new Date().getFullYear() + '-01-01' + ' 00:00:00').format(
      'YYYY-MM-DD HH:mm:ss'
    );
  };

  const startOfLastYear = () => {
    return moment(new Date().getFullYear() - 1 + '-01-01' + ' 00:00:00').format(
      'YYYY-MM-DD HH:mm:ss'
    );
  };
  const endOfLastYear = () => {
    return moment(new Date().getFullYear() - 1 + '-12-31' + ' 00:00:00').format(
      'YYYY-MM-DD HH:mm:ss'
    );
  };

  const endOfPreviousMonth = () => {
    return moment(
      moment().subtract(1, 'months').endOf('month').format('YYYY-MM-DD') +
      ' 23:59:59'
    )
      .utc()
      .format('YYYY-MM-DD HH:mm:ss');
  };

  const endOfMonth = () => {
    return moment(moment().endOf('month').format('YYYY-MM-DD') + ' 23:59:59')
      .utc()
      .format('YYYY-MM-DD HH:mm:ss');
  };

  const selectLast7Days = () => {
    setButtonText(<IntlMessages id="dashboards.last-7-days" />);
    setLabels(last7Days);

    setfromDate(daysAgo7());
    settoDate(today());

    setIsWebsiteVisit(false);

    setIsSales(true);
    setIsClicks(true);
    setIsStats(true);
    setIsCountryStats(true);
    Axios.all([
      AxiosAPI({
        method: 'get',
        url: `${gAPI_VisitorsGroups_Stats}`,
        params: {
          groupId: getGroupID(),
          dateFrom: daysAgo30(),
          dateTo: today(),
          propertyId: propertyId,
        },
      }).then((res) => {
        setVisitorStatsData(res.data);
        setIsWebsiteVisit(false);
      }),
      AxiosAPI({
        method: 'get',
        url: `${gAPI_VisitorsGroupsContact_Stats}`,
        params: {
          groupId: getGroupID(),
          dateFrom: daysAgo30(),
          dateTo: today(),
          propertyId: propertyId,
        },
      }).then((res) => {
        setContactStatsData(res.data);
        setContacts(false);
      }),
      AxiosAPI({
        method: 'get',
        url: `${gAPI_Voucher_Country_Stats}`,
        params: {
          groupId: getGroupID(),
          dateFrom: daysAgo7(),
          dateTo: today(),
          propertyId: propertyId,
        },
      }).then((res) => {
        setCountryVisit(res.data);
        setIsCountryStats(false);
      }),

      AxiosAPI({
        method: 'get',
        url: `${gAPI_Voucher_Engine_Sales}`,
        params: {
          group_id: getGroupID(),
          property_id: propertyId,
          fromDate: daysAgo7(),
          toDate: today(),
          type: 'Day',
        },
      }).then((res) => {
        setSales(res.data);
        setIsSales(false);
      }),
      AxiosAPI({
        method: 'get',
        url: `${gAPI_Voucher_Engine_Stats}`,
        params: {
          group_id: getGroupID(),
          property_id: propertyId,
          fromDate: daysAgo7(),
          toDate: today(),
          type: 'Day',
        },
      }).then((res) => {
        setClicks(res.data);
        setIsClicks(false);
      }),
      AxiosAPI({
        method: 'get',
        url: `${gAPI_Voucher_Stats}`,
        params: {
          group_id: getGroupID(),
          property_id: propertyId,
          fromDate: daysAgo7(),
          toDate: today(),
          type: 'Day',
        },
      }).then((res) => {
        setStats(res.data);
        setIsStats(false);
        let v = 0,
          s = 0;
        res.data.voucher.map((m) => {
          v = v + parseInt(m.views);
          s = s + parseInt(m.purchases);
        });
        setStatsData({ views: v, sold: s });
      }),
    ]);
  };

  const selectLast30Days = () => {
    setButtonText(<IntlMessages id="dashboards.last-30-days" />);
    setLabels(last30Days);

    setfromDate(daysAgo30());
    settoDate(today());

    setIsWebsiteVisit(false);

    setIsSales(true);
    setIsClicks(true);
    setIsStats(true);
    setIsCountryStats(true);
    Axios.all([
      AxiosAPI({
        method: 'get',
        url: `${gAPI_VisitorsGroups_Stats}`,
        params: {
          groupId: getGroupID(),
          dateFrom: daysAgo30(),
          dateTo: today(),
          propertyId: propertyId,
        },
      }).then((res) => {
        setVisitorStatsData(res.data);
        setIsWebsiteVisit(false);
      }),
      AxiosAPI({
        method: 'get',
        url: `${gAPI_VisitorsGroupsContact_Stats}`,
        params: {
          groupId: getGroupID(),
          dateFrom: daysAgo30(),
          dateTo: today(),
          propertyId: propertyId,
        },
      }).then((res) => {
        setContactStatsData(res.data);
        setContacts(false);
      }),
      AxiosAPI({
        method: 'get',
        url: `${gAPI_Voucher_Country_Stats}`,
        params: {
          groupId: getGroupID(),
          dateFrom: daysAgo30(),
          dateTo: today(),
          propertyId: propertyId,
        },
      }).then((res) => {
        setCountryVisit(res.data);
        setIsCountryStats(false);
      }),
      AxiosAPI({
        method: 'get',
        url: `${gAPI_Voucher_Stats}`,
        params: {
          group_id: getGroupID(),
          property_id: propertyId,
          fromDate: daysAgo30(),
          toDate: today(),
          type: 'Day',
        },
      }).then((res) => {
        setStats(res.data);
        setIsStats(false);
        let v = 0,
          s = 0;
        res.data.voucher.map((m) => {
          v = v + parseInt(m.views);
          s = s + parseInt(m.purchases);
        });
        setStatsData({ views: v, sold: s });
      }),
      AxiosAPI({
        method: 'get',
        url: `${gAPI_Voucher_Engine_Sales}`,
        params: {
          group_id: getGroupID(),
          property_id: propertyId,
          fromDate: daysAgo30(),
          toDate: today(),
          type: 'Day',
        },
      }).then((res) => {
        setSales(res.data);
        setIsSales(false);
      }),
      AxiosAPI({
        method: 'get',
        url: `${gAPI_Voucher_Engine_Stats}`,
        params: {
          group_id: getGroupID(),
          property_id: propertyId,
          fromDate: daysAgo30(),
          toDate: today(),
          type: 'Day',
        },
      }).then((res) => {
        setClicks(res.data);
        setIsClicks(false);
      }),
    ]);
  };
  const selectLast90Days = () => {
    setButtonText(<IntlMessages id="dashboards.last-90-days" />);
    setLabels(last90Days);
    setfromDate(daysAgo90());
    settoDate(today());
    setIsWebsiteVisit(false);

    setIsSales(true);
    setIsClicks(true);
    setIsStats(true);
    setIsCountryStats(true);
    Axios.all([
      AxiosAPI({
        method: 'get',
        url: `${gAPI_VisitorsGroups_Stats}`,
        params: {
          groupId: getGroupID(),
          dateFrom: daysAgo90(),
          dateTo: today(),
          propertyId: propertyId,
        },
      }).then((res) => {
        setVisitorStatsData(res.data);
        setIsWebsiteVisit(false);
      }),
      AxiosAPI({
        method: 'get',
        url: `${gAPI_VisitorsGroupsContact_Stats}`,
        params: {
          groupId: getGroupID(),
          dateFrom: daysAgo90(),
          dateTo: today(),
          propertyId: propertyId,
        },
      }).then((res) => {
        setContactStatsData(res.data);
        setContacts(false);
      }),
      AxiosAPI({
        method: 'get',
        url: `${gAPI_Voucher_Stats}`,
        params: {
          group_id: getGroupID(),
          property_id: propertyId,
          fromDate: daysAgo90(),
          toDate: today(),
          type: 'Day',
        },
      }).then((res) => {
        setStats(res.data);
        setIsStats(false);
        let v = 0,
          s = 0;
        res.data.voucher.map((m) => {
          v = v + parseInt(m.views);
          s = s + parseInt(m.purchases);
        });
        setStatsData({ views: v, sold: s });
      }),
      AxiosAPI({
        method: 'get',
        url: `${gAPI_Voucher_Engine_Sales}`,
        params: {
          group_id: getGroupID(),
          property_id: propertyId,
          fromDate: daysAgo90(),
          toDate: today(),
          type: 'Day',
        },
      }).then((res) => {
        setSales(res.data);
        setIsSales(false);
      }),
      AxiosAPI({
        method: 'get',
        url: `${gAPI_Voucher_Engine_Stats}`,
        params: {
          group_id: getGroupID(),
          property_id: propertyId,
          fromDate: daysAgo90(),
          toDate: today(),
          type: 'Day',
        },
      }).then((res) => {
        setClicks(res.data);
        setIsClicks(false);
      }),
      AxiosAPI({
        method: 'get',
        url: `${gAPI_Voucher_Country_Stats}`,
        params: {
          groupId: getGroupID(),
          dateFrom: daysAgo90(),
          dateTo: today(),
          propertyId: propertyId,
        },
      }).then((res) => {
        setCountryVisit(res.data);
        setIsCountryStats(false);
      }),
    ]);
  };

  const selectThisWeek = () => {
    setButtonText(<IntlMessages id="dashboards.this-week" />);
    setLabels(week);

    setfromDate(startOfWeek());
    settoDate(endOfWeek());

    setIsWebsiteVisit(false);

    setIsSales(true);
    setIsClicks(true);
    setIsStats(true);
    setIsCountryStats(true);
    Axios.all([
      AxiosAPI({
        method: 'get',
        url: `${gAPI_VisitorsGroups_Stats}`,
        params: {
          groupId: getGroupID(),
          dateFrom: startOfWeek(),
          dateTo: endOfWeek(),
          propertyId: propertyId,
        },
      }).then((res) => {
        setVisitorStatsData(res.data);
        setIsWebsiteVisit(false);
      }),
      AxiosAPI({
        method: 'get',
        url: `${gAPI_VisitorsGroupsContact_Stats}`,
        params: {
          groupId: getGroupID(),
          dateFrom: startOfWeek(),
          dateTo: endOfWeek(),
          propertyId: propertyId,
        },
      }).then((res) => {
        setContactStatsData(res.data);
        setContacts(false);
      }),
      AxiosAPI({
        method: 'get',
        url: `${gAPI_Voucher_Stats}`,
        params: {
          group_id: getGroupID(),
          property_id: propertyId,
          fromDate: startOfWeek(),
          toDate: endOfWeek(),
          type: 'Day',
        },
      }).then((res) => {
        setStats(res.data);
        setIsStats(false);
        let v = 0,
          s = 0;
        res.data.voucher.map((m) => {
          v = v + parseInt(m.views);
          s = s + parseInt(m.purchases);
        });
        setStatsData({ views: v, sold: s });
      }),
      AxiosAPI({
        method: 'get',
        url: `${gAPI_Voucher_Engine_Sales}`,
        params: {
          group_id: getGroupID(),
          property_id: propertyId,
          fromDate: startOfWeek(),
          toDate: endOfWeek(),
          type: 'Day',
        },
      }).then((res) => {
        setSales(res.data);
        setIsSales(false);
      }),
      AxiosAPI({
        method: 'get',
        url: `${gAPI_Voucher_Country_Stats}`,
        params: {
          groupId: getGroupID(),
          dateFrom: startOfWeek(),
          dateTo: endOfWeek(),
          propertyId: propertyId,
        },
      }).then((res) => {
        setCountryVisit(res.data);
        setIsCountryStats(false);
      }),

      AxiosAPI({
        method: 'get',
        url: `${gAPI_Voucher_Engine_Stats}`,
        params: {
          group_id: getGroupID(),
          property_id: propertyId,
          fromDate: startOfWeek(),
          toDate: endOfWeek(),
          type: 'Day',
        },
      }).then((res) => {
        setClicks(res.data);
        setIsClicks(false);
      }),
    ]);
  };

  const selectThisMonth = () => {
    setButtonText(<IntlMessages id="dashboards.this-month" />);
    setLabels(month);

    setfromDate(startOfMonth());
    settoDate(endOfMonth());

    setIsWebsiteVisit(false);

    setIsSales(true);
    setIsClicks(true);
    setIsStats(true);
    setIsCountryStats(true);
    Axios.all([
      AxiosAPI({
        method: 'get',
        url: `${gAPI_VisitorsGroupsContact_Stats}`,
        params: {
          groupId: getGroupID(),
          dateFrom: startOfMonth(),
          dateTo: endOfMonth(),
          propertyId: propertyId,
        },
      }).then((res) => {
        setContactStatsData(res.data);
        setContacts(false);
      }),
      AxiosAPI({
        method: 'get',
        url: `${gAPI_VisitorsGroups_Stats}`,
        params: {
          groupId: getGroupID(),
          dateFrom: startOfMonth(),
          dateTo: endOfMonth(),
          propertyId: propertyId,
        },
      }).then((res) => {
        setVisitorStatsData(res.data);
        setIsWebsiteVisit(false);
      }),
      AxiosAPI({
        method: 'get',
        url: `${gAPI_Voucher_Stats}`,
        params: {
          group_id: getGroupID(),
          property_id: propertyId,
          fromDate: startOfMonth(),
          toDate: endOfMonth(),
          type: 'Day',
        },
      }).then((res) => {
        setStats(res.data);
        setIsStats(false);
        let v = 0,
          s = 0;
        res.data.voucher.map((m) => {
          v = v + parseInt(m.views);
          s = s + parseInt(m.purchases);
        });
        setStatsData({ views: v, sold: s });
      }),
      AxiosAPI({
        method: 'get',
        url: `${gAPI_Voucher_Engine_Sales}`,
        params: {
          group_id: getGroupID(),
          property_id: propertyId,
          fromDate: startOfMonth(),
          toDate: endOfMonth(),
          type: 'Day',
        },
      }).then((res) => {
        setSales(res.data);
        setIsSales(false);
      }),
      AxiosAPI({
        method: 'get',
        url: `${gAPI_Voucher_Engine_Stats}`,
        params: {
          group_id: getGroupID(),
          property_id: propertyId,
          fromDate: startOfMonth(),
          toDate: endOfMonth(),
          type: 'Day',
        },
      }).then((res) => {
        setClicks(res.data);
        setIsClicks(false);
      }),
      AxiosAPI({
        method: 'get',
        url: `${gAPI_Voucher_Country_Stats}`,
        params: {
          groupId: getGroupID(),
          propertyId: propertyId,
          dateFrom: startOfMonth(),
          dateTo: endOfMonth(),
        },
      }).then((res) => {
        setCountryVisit(res.data);
        setIsCountryStats(false);
      }),
    ]);
  };

  const selectPreviousMonth = () => {
    setButtonText(<IntlMessages id="dashboards.previous-month" />);
    setLabels(month);

    setfromDate(startOfPreviousMonth());
    settoDate(endOfPreviousMonth());

    setIsWebsiteVisit(false);

    setIsSales(true);
    setIsClicks(true);
    setIsStats(true);
    setIsCountryStats(true);
    Axios.all([
      AxiosAPI({
        method: 'get',
        url: `${gAPI_VisitorsGroupsContact_Stats}`,
        params: {
          groupId: getGroupID(),
          dateFrom: startOfPreviousMonth(),
          dateTo: endOfPreviousMonth(),
          propertyId: propertyId,
        },
      }).then((res) => {
        setContactStatsData(res.data);
        setContacts(false);
      }),
      AxiosAPI({
        method: 'get',
        url: `${gAPI_VisitorsGroups_Stats}`,
        params: {
          groupId: getGroupID(),
          dateFrom: startOfPreviousMonth(),
          dateTo: endOfPreviousMonth(),
          propertyId: propertyId,
        },
      }).then((res) => {
        setVisitorStatsData(res.data);
        setIsWebsiteVisit(false);
      }),
      AxiosAPI({
        method: 'get',
        url: `${gAPI_Voucher_Stats}`,
        params: {
          group_id: getGroupID(),
          property_id: propertyId,
          fromDate: startOfPreviousMonth(),
          toDate: endOfPreviousMonth(),
          type: 'Day',
        },
      }).then((res) => {
        setStats(res.data);
        setIsStats(false);
        let v = 0,
          s = 0;
        res.data.voucher.map((m) => {
          v = v + parseInt(m.views);
          s = s + parseInt(m.purchases);
        });
        setStatsData({ views: v, sold: s });
      }),
      AxiosAPI({
        method: 'get',
        url: `${gAPI_Voucher_Engine_Sales}`,
        params: {
          group_id: getGroupID(),
          property_id: propertyId,
          fromDate: startOfPreviousMonth(),
          toDate: endOfPreviousMonth(),
          type: 'Day',
        },
      }).then((res) => {
        setSales(res.data);
        setIsSales(false);
      }),
      AxiosAPI({
        method: 'get',
        url: `${gAPI_Voucher_Engine_Stats}`,
        params: {
          group_id: getGroupID(),
          property_id: propertyId,
          fromDate: startOfPreviousMonth(),
          toDate: endOfPreviousMonth(),
          type: 'Day',
        },
      }).then((res) => {
        setClicks(res.data);
        setIsClicks(false);
      }),
      AxiosAPI({
        method: 'get',
        url: `${gAPI_Voucher_Country_Stats}`,
        params: {
          groupId: getGroupID(),
          propertyId: propertyId,
          dateFrom: startOfPreviousMonth(),
          dateTo: endOfPreviousMonth(),
        },
      }).then((res) => {
        setCountryVisit(res.data);
        setIsCountryStats(false);
      }),
    ]);
  };

  const selectThisYear = () => {
    setButtonText(<IntlMessages id="dashboards.yeartodate" />);

    setfromDate(startOfThisYear());
    settoDate(today());

    setIsWebsiteVisit(false);

    setLabels(year);
    setIsSales(true);
    setIsClicks(true);
    setIsStats(true);
    setIsCountryStats(true);
    Axios.all([
      AxiosAPI({
        method: 'get',
        url: `${gAPI_VisitorsGroupsContact_Stats}`,
        params: {
          groupId: getGroupID(),
          dateFrom: startOfThisYear(),
          dateTo: today(),
          propertyId: propertyId,
        },
      }).then((res) => {
        setContactStatsData(res.data);
        setContacts(false);
      }),
      AxiosAPI({
        method: 'get',
        url: `${gAPI_VisitorsGroups_Stats}`,
        params: {
          groupId: getGroupID(),
          dateFrom: startOfThisYear(),
          dateTo: today(),
          propertyId: propertyId,
        },
      }).then((res) => {
        setVisitorStatsData(res.data);
        setIsWebsiteVisit(false);
      }),
      AxiosAPI({
        method: 'get',
        url: `${gAPI_Voucher_Stats}`,
        params: {
          group_id: getGroupID(),
          property_id: propertyId,
          fromDate: startOfThisYear(),
          toDate: today(),
          type: 'Month',
        },
      }).then((res) => {
        setStats(res.data);
        setIsStats(false);
        let v = 0,
          s = 0;
        res.data.voucher.map((m) => {
          v = v + parseInt(m.views);
          s = s + parseInt(m.purchases);
        });
        setStatsData({ views: v, sold: s });
      }),
      AxiosAPI({
        method: 'get',
        url: `${gAPI_Voucher_Engine_Sales}`,
        params: {
          group_id: getGroupID(),
          property_id: propertyId,
          fromDate: startOfThisYear(),
          toDate: today(),
          type: 'Month',
        },
      }).then((res) => {
        setSales(res.data);
        setIsSales(false);
      }),
      AxiosAPI({
        method: 'get',
        url: `${gAPI_Voucher_Engine_Stats}`,
        params: {
          group_id: getGroupID(),
          property_id: propertyId,
          fromDate: startOfThisYear(),
          toDate: today(),
          type: 'Month',
        },
      }).then((res) => {
        setClicks(res.data);
        setIsClicks(false);
      }),
      AxiosAPI({
        method: 'get',
        url: `${gAPI_Voucher_Country_Stats}`,
        params: {
          groupId: getGroupID(),
          dateFrom: startOfThisYear(),
          dateTo: today(),
          propertyId: propertyId,
        },
      }).then((res) => {
        setCountryVisit(res.data);
        setIsCountryStats(false);
      }),
    ]);
  };

  const selectLastYear = () => {
    setButtonText(<IntlMessages id="dashboards.lastyear" />);
    setLabels(year);
    setIsSales(true);
    setIsClicks(true);
    setIsStats(true);
    setIsCountryStats(true);

    setfromDate(startOfLastYear());
    settoDate(endOfLastYear());

    setIsWebsiteVisit(false);

    setIsSales(true);
    setIsClicks(true);
    setIsStats(true);
    setIsCountryStats(true);
    Axios.all([
      AxiosAPI({
        method: 'get',
        url: `${gAPI_VisitorsGroupsContact_Stats}`,
        params: {
          groupId: getGroupID(),
          dateFrom: startOfLastYear(),
          dateTo: endOfLastYear(),
          propertyId: propertyId,
        },
      }).then((res) => {
        setContactStatsData(res.data);
        setContacts(false);
      }),
      AxiosAPI({
        method: 'get',
        url: `${gAPI_VisitorsGroups_Stats}`,
        params: {
          groupId: getGroupID(),
          dateFrom: startOfLastYear(),
          dateTo: endOfLastYear(),
          propertyId: propertyId,
        },
      }).then((res) => {
        setVisitorStatsData(res.data);
        setIsWebsiteVisit(false);
      }),
      AxiosAPI({
        method: 'get',
        url: `${gAPI_Voucher_Stats}`,
        params: {
          group_id: getGroupID(),
          property_id: propertyId,
          fromDate: startOfLastYear(),
          toDate: endOfLastYear(),
          type: 'Month',
        },
      }).then((res) => {
        setStats(res.data);
        setIsStats(false);
        let v = 0,
          s = 0;
        res.data.voucher.map((m) => {
          v = v + parseInt(m.views);
          s = s + parseInt(m.purchases);
        });
        setStatsData({ views: v, sold: s });
      }),
      AxiosAPI({
        method: 'get',
        url: `${gAPI_Voucher_Engine_Sales}`,
        params: {
          group_id: getGroupID(),
          property_id: propertyId,
          fromDate: startOfLastYear(),
          toDate: endOfLastYear(),
          type: 'Month',
        },
      }).then((res) => {
        setSales(res.data);
        setIsSales(false);
      }),
      AxiosAPI({
        method: 'get',
        url: `${gAPI_Voucher_Engine_Stats}`,
        params: {
          group_id: getGroupID(),
          property_id: propertyId,
          fromDate: startOfLastYear(),
          toDate: endOfLastYear(),
          type: 'Month',
        },
      }).then((res) => {
        setClicks(res.data);
        setIsClicks(false);
      }),
      AxiosAPI({
        method: 'get',
        url: `${gAPI_Voucher_Country_Stats}`,
        params: {
          groupId: getGroupID(),
          dateFrom: startOfLastYear(),
          dateTo: endOfLastYear(),
          propertyId: propertyId,
        },
      }).then((res) => {
        setCountryVisit(res.data);
        setIsCountryStats(false);
      }),
    ]);
  };

  return (
    <Fragment>
      <Row>
        <Col xxs="12" className="mb-4">
          <Card>
            <CardBody>
              <div className="btn-group float-right float-none-xs mt-2">
                <UncontrolledDropdown>
                  <DropdownToggle
                    caret
                    color="primary"
                    className="btn-xs"
                    outline
                  >
                    {buttonText}
                  </DropdownToggle>
                  <DropdownMenu right>
                    <DropdownItem onClick={selectLast7Days}>
                      <IntlMessages id="dashboards.last-7-days" />
                    </DropdownItem>
                    <DropdownItem onClick={selectLast30Days}>
                      <IntlMessages id="dashboards.last-30-days" />
                    </DropdownItem>
                    <DropdownItem onClick={selectLast90Days}>
                      <IntlMessages id="dashboards.last-90-days" />
                    </DropdownItem>
                    <DropdownItem onClick={selectThisWeek}>
                      <IntlMessages id="dashboards.this-week" />
                    </DropdownItem>
                    <DropdownItem onClick={selectThisMonth}>
                      <IntlMessages id="dashboards.this-month" />
                    </DropdownItem>
                    <DropdownItem onClick={selectPreviousMonth}>
                      <IntlMessages id="dashboards.previous-month" />
                    </DropdownItem>
                    <DropdownItem onClick={selectThisYear}>
                      <IntlMessages id="dashboards.yeartodate" />
                    </DropdownItem>
                    <DropdownItem onClick={selectLastYear}>
                      <IntlMessages id="dashboards.lastyear" />
                    </DropdownItem>
                  </DropdownMenu>
                </UncontrolledDropdown>
              </div>
            </CardBody>
          </Card>
        </Col>
      </Row>
      <Row>
        {isVoucherEngine || domains.length == 1 ? (
          <Col sm="12" md="6" className="mb-4">
            {isSales ? (
              <div className="text-center loading" />
            ) : (
              <VoucherEngineSales labels={labels} data={sales.dataset} />
              // <p style={{ textAlign: 'center' }}>Temporarily Unavailable</p>
            )}
          </Col>
        ) : (
          ''
        )}
        {isVoucherEngine || domains.length == 1 ? (
          <Col sm="12" md="6" className="mb-4">
            {isclicks ? (
              <div className="text-center loading" />
            ) : (
              <VoucherClicks labels={labels} data={clicks.dataset} />
              // <p style={{ textAlign: 'center' }}>Temporarily Unavailable</p>
            )}
          </Col>
        ) : (
          ''
        )}

        {isVoucherEngine || domains.length == 1 ? (
          <Col sm="12" md="6" className="mb-4">
            {isStats ? (
              <div className="text-center loading" />
            ) : (
              <PopularVoucher
                labels={poupularVoucherDataTablescolumn}
                data={stats.voucher}
                revenue={sales.revenue}
                locale={locale}
                statsData={statsData}
                currency={currency}
                clicks={clicks.clicks}
              />
              // <p style={{ textAlign: 'center' }}>Temporarily Unavailable</p>
            )}
          </Col>
        ) : (
          ''
        )}
        {isVoucherEngine || domains.length == 1 ? (
          <Col sm="12" md="6" className="mb-4">
            {
              isStats ? (
                <div className="text-center">
                  <Spinner color="primary" className="mb-1" />
                </div>
              ) : (
                stats.recentOrders.length > 0 && (
                  <RecentOrder data={stats.recentOrders} />
                )
              )
              // <p style={{ textAlign: 'center' }}>Temporarily Unavailable</p>
            }
          </Col>
        ) : (
          ''
        )}

        {isVoucherEngine || domains.length == 1 ? (
          <Col sm="12" md="6" className="mb-4">
            {isCountryStats ? (
              <div className="text-center loading" />
            ) : (
              countryvisit.length > 0 && (
                <VoucherEngineVisits
                  labels={voucherEngineVisits}
                  data={countryvisit}
                />
              )
            )}
          </Col>
        ) : (
          ''
        )}
      </Row>
    </Fragment>
  );
}
const mapStateToProps = ({ authUser, settings, oidc }) => {
  const { user: loginUser } = authUser;
  const {
    locale,
    propertyId,
    isVoucherEngine,
    timeZone,
    email,
    domains,
    currency,
  } = settings;
  return {
    loginUser,
    locale,
    oidc,
    isVoucherEngine,
    propertyId,
    timeZone,
    email,
    domains,
    currency,
  };
};

const mapActionsToProps = {};

const aap = injectIntl(Insights);
export default connect(mapStateToProps, mapActionsToProps)(aap);
